import React, { useLayoutEffect } from 'react';
import "../Css/Termsandconditions.css";
import Footer from '../Component/Footer/Footer';

const Termsandconditions = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0)
});
  return (
    <div>
      <div className='Terms-and-conditions-page'>
        <div className='container'>
            <div className='Terms-and-conditions-page'>
                <h2>Privacy & Policy</h2>

                <h3>Privacy & Policy</h3>
                <p>We value your trust and are committed to protecting your personal information. Please review the following policies for better understanding of your rights and responsibilities</p>

                <h3>Privacy Policy</h3>
                <p>We collect only the necessary personal details such as name, address, contact number, and payment information to process your order smoothly.</p>
                <p>Your data is used strictly for order processing, delivery, and customer service purposes.</p>
                <p>We do not share, sell, or rent your personal information to any third-party without your consent, except as required by law.</p>
                <p>Our website uses secure encryption technology to safeguard your data.</p>
                <p>By using our services, you agree to the collection and use of information in accordance with this policy.</p>


                <h3>Terms & Conditions</h3>
                <p>All customers must provide accurate and complete details while placing an order.</p>
                <p>Product images on the website are for representation only; actual product appearance may vary slightly.</p>
                <p>We reserve the right to update or modify the terms at any time without prior notice.</p>
                <p>Continued use of the website after changes implies acceptance of the updated terms.</p>

                <h3>Return Policy</h3>
                <p>Customers can return a product within 7-10 working days of receiving it.</p>
                <p>The product must be unused, in original packaging, and accompanied by a receipt/invoice.</p>
                <p>Returns may not be accepted if the product is damaged or tampered with.</p>

                <h3>Refund Policy</h3>
                <p>Once the returned product is inspected and approved, refunds will be initiated.</p>
                <p>Refunds will be credited to the original payment method within 7-10 working days.</p>
                <p>Shipping charges may not be refunded.</p>

                <h3>Shipping Policy</h3>
                <p>Orders are processed within 1-2 working days after confirmation.</p>
                <p>Products will be delivered within 7-10 working days, depending on the delivery location.</p>
                <p>Tracking details will be shared once the product is dispatched.</p>
            </div>
        </div>
      </div>

               <Footer />
      
    </div>
  )
}

export default Termsandconditions
